import { render, staticRenderFns } from "./BranchDistrictGender.vue?vue&type=template&id=4f03aa60&scoped=true&"
import script from "./BranchDistrictGender.vue?vue&type=script&lang=js&"
export * from "./BranchDistrictGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03aa60",
  null
  
)

export default component.exports